export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/grid-view-icon.be2a6105.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};